import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';

import { LoginScreen } from '../../modules/Auth/screens/LoginScreen';
import { OtpVerifyScreen } from '../../modules/Auth/screens/OtpVerifyScreen';
import { registerAuthOverlayController } from './authOverlayController';

type OtpParams = {
  phoneNumber: string;
  dialCode: string;
  localNumber: string;
};

type OverlayNav = {
  navigate: (name: 'OtpVerify', params: OtpParams) => void;
  goBack: () => void;
};

/**
 * Web auth host — paints over MainTabs without a stack screen card
 * (native-stack transparentModal on web leaves a solid gray scene).
 */
export function AuthOverlayHost() {
  const [open, setOpen] = useState(false);
  const [otpParams, setOtpParams] = useState<OtpParams | null>(null);

  useEffect(() => {
    registerAuthOverlayController({
      open: () => {
        setOtpParams(null);
        setOpen(true);
      },
      close: () => {
        setOpen(false);
        setOtpParams(null);
      },
    });
    return () => registerAuthOverlayController(null);
  }, []);

  if (!open) {
    return null;
  }

  const navigation = {
    navigate: (_name: 'OtpVerify', params: OtpParams) => setOtpParams(params),
    goBack: () => setOtpParams(null),
  } as OverlayNav;

  return (
    <View style={styles.host} pointerEvents="box-none">
      {otpParams ? (
        <OtpVerifyScreen
          navigation={navigation as never}
          route={{ key: 'OtpVerify', name: 'OtpVerify', params: otpParams } as never}
        />
      ) : (
        <LoginScreen
          navigation={navigation as never}
          route={{ key: 'Login', name: 'Login', params: undefined } as never}
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  host: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 100,
    backgroundColor: 'transparent',
  },
});
